import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Constants } from '../share/constants';
import { CoordinatesModel } from '../share/models';
import { WeatherApiCallParameters } from '../share/enums';
import { ReverseGeocodeResponse } from '../share/interfaces';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class BigDataService {

  constructor(private httpClient: HttpClient) { }


  getLocationData(location: CoordinatesModel): Observable<string> {
    const params = this.createRequestParameters(location);

    return this.httpClient.get<ReverseGeocodeResponse>(Constants.BIG_DATA_API_ENDPOINT, { params: params }).pipe(
      map(response => {
        const locality = response.locality;
        const principalSubdivision = response.principalSubdivision;
        const countryName = response.countryName;

        if (locality && principalSubdivision && countryName) {
          return `${locality}-${principalSubdivision}/${countryName}`;
        } else {
          // You can return a default string or throw an error for a more specific issue
          throw new Error('Required geographical data (locality, subdivision, or country) not found in the response.');
        }
      }),
      catchError(error => {
        console.error('Error fetching geocoding data:', error);
        return 'Özel Konum Bilgisi Bulunamadı';

      })
    );
  }
  createRequestParameters(location: CoordinatesModel) {
    return new HttpParams().set(WeatherApiCallParameters.lat, location.latitude)
      .set(WeatherApiCallParameters.long, location.longitude.toString())
      .set(WeatherApiCallParameters.key, Constants.BIG_DATA_API_KEY)
      .set('localityLanguage', 'tr')

  }
}
